import { ONBOARDING_STEPS } from 'utils/onboarding-checklist-constants';
import type { OnboardingStepId, OnboardingStepStatus } from 'utils/onboarding-checklist-storage';

export const ONBOARDING_REWARD_24H_SHOWN_KEY = 'berry-onboarding-reward-24h-v1';

export function hasReward24hModalBeenShown(): boolean {
  try {
    return typeof localStorage !== 'undefined' && localStorage.getItem(ONBOARDING_REWARD_24H_SHOWN_KEY) === '1';
  } catch {
    return true;
  }
}

export function markReward24hModalShown(): void {
  try {
    localStorage.setItem(ONBOARDING_REWARD_24H_SHOWN_KEY, '1');
  } catch {
    /* ignore */
  }
}

/** כל השלבים מסומנים done (לא skipped) */
export function hasAllOnboardingStepsDone(steps: Record<OnboardingStepId, OnboardingStepStatus>): boolean {
  return ONBOARDING_STEPS.every((s) => steps[s.id] === 'done');
}

const BONUS_MS = 24 * 60 * 60 * 1000;

/** שעות שלמות שנותרו בחלון 24 שעות מההרשמה; null אם אין תאריך */
export function getBonusHoursRemaining(signupIso: string | null | undefined): number | null {
  if (!signupIso) return null;
  const t = new Date(signupIso).getTime();
  if (Number.isNaN(t)) return null;
  const end = t + BONUS_MS;
  const r = end - Date.now();
  if (r <= 0) return 0;
  return Math.max(1, Math.ceil(r / (60 * 60 * 1000)));
}

export function isWithin24HoursOfSignup(signupIso: string | null | undefined): boolean {
  if (!signupIso) return false;
  const t = new Date(signupIso).getTime();
  if (Number.isNaN(t)) return false;
  return Date.now() - t <= BONUS_MS;
}
